















import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'

import { Point } from '@/models/point/list/point'
import TableCell from './TableCell.vue'
import TableRow from './TableRow.vue'

@Component({
  components: { TableRow, TableCell },
})
export default class PointRow extends Vue {
  @Prop({ required: true })
  readonly point: Point

  get lastAvailableDate(): string {
    return this.point.lastAvailableDate
  }
}
